<div class="modal-header custom-header py-3 flex-column align-items-start">
    <div class="d-flex justify-content-between w-100 align-items-start">
        <div>
            <h5 class="modal-title mb-1 sd-text-primary fs-6">Need Any Help Today?</h5>
            <p class="mb-0 text-muted small">Our support team is available to assist you.</p>
        </div>
        <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
    </div>
</div>

<div class="modal-body pb-2 pt-2">

    <div class="alert alert-danger d-flex align-items-center gap-2 mb-0 py-2" *ngIf="hasError">
        <i class="fa fa-exclamation-circle"></i>
        <span class="fw-semibold small">Unable to load support information.</span>
    </div>

    <div *ngIf="!hasError">
        <div class="card border-0 shadow-sm mb-2" *ngFor="let shift of supportShifts">
            <div class="card-body p-2">

                <div class="d-flex align-items-center justify-content-between mb-2 pb-1 border-bottom">
                    <span class="badge rounded-pill bg-primary px-2 py-1 small">
                        Shift {{ shift.shiftNo }}
                    </span>
                    <span class="badge rounded-pill px-2 py-1 small"
                        [ngClass]="shift.isActive ? 'bg-success-subtle text-success-emphasis' : 'bg-secondary-subtle text-secondary-emphasis'">
                        {{ shift.isActive ? 'Active' : 'Inactive' }}
                    </span>
                </div>

                <div class="d-flex align-items-center mb-1">
                    <span
                        class="d-inline-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded-circle me-2 flex-shrink-0"
                        style="width: 24px; height: 24px; font-size: 11px;">
                        <i class="fa fa-user"></i>
                    </span>
                    <span class="fw-semibold text-dark small">{{ shift.contactPerson }}</span>
                </div>

                <div class="d-flex align-items-center mb-1">
                    <span
                        class="d-inline-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded-circle me-2 flex-shrink-0"
                        style="width: 24px; height: 24px; font-size: 11px;">
                        <i class="fa fa-phone"></i>
                    </span>
                    <a class="text-dark text-decoration-none small" [href]="'tel:' + shift.supportNumber">
                        {{ shift.supportNumber }}
                    </a>
                </div>

                <div class="d-flex align-items-center">
                    <span
                        class="d-inline-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded-circle me-2 flex-shrink-0"
                        style="width: 24px; height: 24px; font-size: 11px;">
                        <i class="fa fa-clock"></i>
                    </span>
                    <span class="text-dark small">{{ formatTime(shift.fromTime) }} - {{ formatTime(shift.toTime) }}</span>
                </div>

            </div>
        </div>

        <div class="text-center text-muted py-2 small" *ngIf="supportShifts.length === 0">
            No support information available.
        </div>
    </div>
</div>

<!-- <div class="modal-footer">
    <button class="btn sd-custom-btn rounded-2 btn-sm" (click)="confirm()">Yes</button>
    <button class="btn btn-success rounded-2 btn-sm" (click)="cancel()">Continue</button>
</div> -->